import "./AirportsWeService.module.css";
import Header from "@/reusable_sections/Header";
import SeamlessAirportTransfers from "./sections/SeamlessAirportTransfers";
import ComprehensiveAirportCoverage from "./sections/ComprehensiveAirportCoverage";
import Footer from "@/reusable_sections/Footer";
export default function AirportsWeServicePage() {
  return <div>
      <Header />
      <SeamlessAirportTransfers />
      <ComprehensiveAirportCoverage />
      <Footer />
    </div>;
}